import React, { useEffect, useState } from "react"

import MenuSection from "./components/MenuSection"
import MenuSectionDataLake from "./components/MenuSectionDataLake"
import theme from "../../theme/theme"
import { Divider, Grid, Typography } from "@mui/material"
import { Box } from "@mui/system"
import * as Styled from "./components/Box.style"
import {
    COMPANY_TITLE,
    CURVE_TITLE,
    EMISSION_TITLE,
    COMPANY,
    CURVE,
    EMISSION,
} from "./constants/datalake.const"
import { CREDIT_CALC, ACCESS, DATALAKE } from "./constants/admin.const"
import {
    CALC_FIX_REND,
    PRECIFICATION,
    RATER,
    RISK_MANAGER,
} from "./constants/system.const"
import Notification from "./components/Notification"
import SideBarLayout from "../../layout/side-bar-layout"
import HomeHeader from "./components/Header"
import GraphStatic from "./components/GraphStatic"
import DashboardService from "../../../services/dashboard-service"
import { TokenService } from "../../../services/token-service"

const HomePage = () => {
    const [isLoadingHomePage, setIsLoadingHomePage] = useState(false)
    const [chartData, setChartData] = useState([])
    const [notificationMessage, setNotificationMessage] = useState([])
    const dashboardService = new DashboardService()
    const tokenService = new TokenService()

    const isAdminUser = tokenService.verifyUserIsAdmin()

    const loadGraphData = async () => {
        setIsLoadingHomePage(true)
        try {
            const response = await dashboardService.loadDashboardChart()
            setChartData(response.body)
        } catch (error) {
            /* empty */
        } finally {
            setIsLoadingHomePage(false)
        }
    }

    const loadNotificationMessage = async () => {
        setNotificationMessage([])
    }

    useEffect(() => {
        loadGraphData()
    }, [])

    useEffect(() => {
        loadNotificationMessage()
    }, [])

    const labelMap = {
        renda_fixa: "Renda Fixa",
        bonds: "Bonds",
        curvas: "Curvas",
    }

    const { labels, c2pData, contractData } = Object.keys(
        chartData || {}
    ).reduce(
        (acc, key) => {
            acc.labels.push(labelMap[key])
            acc.c2pData.push(chartData[key].c2p || 0)
            acc.contractData.push(chartData[key].contratado || 0)
            return acc
        },
        { labels: [], c2pData: [], contractData: [] }
    )

    return (
        <SideBarLayout title="Home">
            <Grid
                sx={{
                    background: theme.palette.background.primary,
                    height: "100%",
                    width: "100%",
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: {
                            xxxs: 0,
                            lg: 209,
                        },
                        right: 0,
                        zIndex: 0,
                    }}
                >
                    <HomeHeader />
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        gap: 3,
                        position: "relative",
                        mt: 34,
                        flexDirection: {
                            xxxs: "column",
                            md: "row",
                        },
                        px: {
                            xxxs: 0,
                            xs: 2,
                            lg: 0,
                        },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 3,
                            minWidth: "339px",
                            width: {
                                xlg: "780px",
                                lg: "670px",
                                md: "379px",
                            },
                        }}
                    >
                        <Styled.BoxMenu
                            sx={{
                                backgroundImage:
                                    "url(/background/background-sistemas.webp)",
                                backgroundSize: "cover",
                            }}
                        >
                            <Typography variant="h2" color="common.white">
                                Sistemas
                            </Typography>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: {
                                        xxxs: "column",
                                        lg: "row",
                                    },
                                    gap: {
                                        xxxs: 3,
                                        lg: 0,
                                    },
                                }}
                            >
                                <Box
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "24px",
                                        width: "100%",
                                        minWidth: "50%",
                                    }}
                                >
                                    <MenuSection
                                        title="Precificação"
                                        items={PRECIFICATION}
                                        tokenService={tokenService}
                                    />
                                    <MenuSection
                                        title={"Rater"}
                                        items={RATER}
                                        tokenService={tokenService}
                                    />
                                </Box>
                                <Box
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "24px",
                                        width: "100%",
                                        minWidth: "50%",
                                    }}
                                >
                                    <MenuSection
                                        title={"Gestor de Recebíveis"}
                                        items={RISK_MANAGER}
                                        tokenService={tokenService}
                                    />
                                    <MenuSection
                                        title={"Calculadora de Renda Fixa"}
                                        items={CALC_FIX_REND}
                                        tokenService={tokenService}
                                        useMaxHeight={true}
                                    />
                                </Box>
                            </Box>
                        </Styled.BoxMenu>
                        <Styled.BoxMenu
                            sx={{
                                backgroundImage:
                                    "url(/background/datalake-menu-background.webp)",
                                backgroundSize: "cover",
                            }}
                        >
                            <Typography variant="h2" color="common.white">
                                Data Lake
                            </Typography>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: {
                                        xxxs: "column",
                                        lg: "row",
                                    },
                                    gap: {
                                        xxxs: 3,
                                        lg: 0,
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        width: "100%",
                                        minWidth: "50%",
                                        gap: {
                                            xxxs: 2,
                                            lg: 0,
                                        },
                                        justifyContent: {
                                            xxxs: undefined,
                                            lg: "space-between",
                                        },
                                    }}
                                >
                                    <MenuSectionDataLake
                                        title={EMISSION_TITLE}
                                        items={EMISSION}
                                        tokenService={tokenService}
                                    />
                                    <MenuSectionDataLake
                                        title={COMPANY_TITLE}
                                        items={COMPANY}
                                        tokenService={tokenService}
                                    />
                                    <MenuSectionDataLake
                                        title={CURVE_TITLE}
                                        items={CURVE}
                                        tokenService={tokenService}
                                    />
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        width: "100%",
                                        minWidth: "50%",
                                    }}
                                >
                                    <Divider
                                        orientation="vertical"
                                        flexItem
                                        sx={{
                                            width: 2,
                                            marginRight: 2,
                                            py: 3,
                                            backgroundColor:
                                                theme.palette.common.white,
                                            border: "none",
                                            "&::before, &::after": {
                                                border: "none",
                                            },
                                        }}
                                    />
                                    <Box>
                                        <Typography
                                            variant="textLarge"
                                            color="common.white"
                                        >
                                            Uso
                                        </Typography>
                                        <GraphStatic
                                            labels={labels}
                                            c2pData={c2pData}
                                            hiredData={contractData}
                                            isLoading={isLoadingHomePage}
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        </Styled.BoxMenu>
                        {isAdminUser && (
                            <Styled.BoxMenu>
                                <Typography variant="h2" color="common.white">
                                    Administrador
                                </Typography>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: {
                                            xxxs: "column",
                                            lg: "row",
                                        },
                                        gap: {
                                            xxxs: 3,
                                            lg: 0,
                                        },
                                    }}
                                >
                                    <Box
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "24px",
                                            width: "100%",
                                            minWidth: "50%",
                                        }}
                                    >
                                        <MenuSection
                                            title="Credit Calc"
                                            items={CREDIT_CALC}
                                            tokenService={tokenService}
                                        />
                                        <MenuSection
                                            title="Acesso"
                                            items={ACCESS}
                                            tokenService={tokenService}
                                        />
                                    </Box>
                                    <Box
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "24px",
                                            width: "100%",
                                            minWidth: "50%",
                                        }}
                                    >
                                        <MenuSection
                                            title="Data Lake"
                                            items={DATALAKE}
                                            tokenService={tokenService}
                                        />
                                    </Box>
                                </Box>
                            </Styled.BoxMenu>
                        )}
                    </Box>
                    <Notification messages={notificationMessage} />
                </Box>
            </Grid>
        </SideBarLayout>
    )
}

export default HomePage
